import type { FC, PropsWithChildren } from "react";

const Modal: FC<PropsWithChildren> = ({ children }) => {
	return (
		<div className="modal__container">
			<div className="modal">{children}</div>
		</div>
	);
};

export { Modal };
